interface IImageProps {
    src: string;
    width?: number|string;
    height?: number|string;
    className?: string;
}

export default function Image({ src, width, height, className }: IImageProps) {
    return (
        <img src={src} width={width} height={height} className={className} />
    );
}
